import { faArrowDownToSquare, faArrowUpFromSquare } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, ButtonGroup } from "@progress/kendo-react-buttons";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { addRecord, handleMoveDown, handleMoveUp } from "../../DatasetUtils.js";
import { datasetData, skip } from "../../NewDatasetSignals.jsx";
import { DeleteCell, PeoplePickerCell } from "./CustomCells.js";

export const UserGroupGrid = ({ onChange }) => {
  const updateListData = (newListData) => {
    onChange(newListData);
  };

  const pageChange = (event) => {
    skip.value = event.page.skip;
  };

  return (
    <Grid
      data={datasetData.value.values}
      style={{ height: "750px" }}
      skip={skip.value}
      total={datasetData.value.values?.length}
      pageSize={20}
      rowHeight={40}
      scrollable="virtual"
      onPageChange={pageChange}
    >
      <GridToolbar>
        <div style={{ display: "flex", alignItems: "center", gap: "5px", flexWrap: "wrap" }}>
          <button
            title="Add new"
            name="btnUserGroupAddRow"
            type="button"
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
            onClick={() =>
              addRecord(datasetData.value.values, updateListData, {
                person: null,
              })
            }
          >
            Add
          </button>
        </div>
      </GridToolbar>
      <GridColumn
        width={80}
        title={null}
        cells={{
          data: renderMoveCell,
        }}
      />
      <GridColumn
        width="450px"
        field="person"
        title="Person"
        cells={{
          data: renderPeoplePickerCell,
        }}
      />
      <GridColumn
        field="delete"
        title="Delete"
        cells={{
          data: renderDeleteCell,
        }}
      />
    </Grid>
  );

  function renderMoveCell(props) {
    return (
      <td>
        <ButtonGroup>
          <Button
            className="!k-px-2"
            onClick={() => handleMoveUp(props, datasetData.value.values, updateListData)}
          >
            <div
              className="align-columns"
              style={{ margin: 0, paddingInline: 0, paddingBlock: 0 }}
            >
              <FontAwesomeIcon
                icon={faArrowUpFromSquare}
                style={{
                  "--fa-primary-color": "#0078D4",
                  "--fa-secondary-color": "#919191",
                  "--fa-primary-opacity": "1",
                  "--fa-secondary-opacity": "1",
                  fontSize: 14,
                }}
              />
            </div>
          </Button>
          <Button
            className="!k-px-2"
            onClick={() => handleMoveDown(props, datasetData.value.values, updateListData)}
          >
            <div
              className="align-columns"
              style={{ margin: 0, paddingInline: 0, paddingBlock: 0 }}
            >
              <FontAwesomeIcon
                icon={faArrowDownToSquare}
                style={{
                  "--fa-primary-color": "#0078D4",
                  "--fa-secondary-color": "#919191",
                  "--fa-primary-opacity": "1",
                  "--fa-secondary-opacity": "1",
                  fontSize: 14,
                }}
              />
            </div>
          </Button>
        </ButtonGroup>
      </td>
    );
  }

  function renderDeleteCell(props) {
    return (
      <DeleteCell
        {...props}
        data={datasetData.value.values}
        setData={updateListData}
      />
    );
  }

  function renderPeoplePickerCell(props) {
    return (
      <PeoplePickerCell
        {...props}
        data={datasetData.value.values}
        setData={updateListData}
      />
    );
  }
};
